import {
  MARK_PATH,
  MARK_VIEWBOX,
  MARK_RATIO,
  DESCRIPTOR_PATH,
  DESCRIPTOR_VIEWBOX,
  DESCRIPTOR_RATIO,
} from './logoPaths';

/**
 * Знак GTO — скруглённая форма с вырезанными литерами.
 * Цвет наследуется от `currentColor`: брендбук допускает только белую
 * или чёрную версию, контраст с фоном обеспечивается местом применения.
 */
export function GtoMark({ height = 28, title }: { height?: number; title?: string }) {
  return (
    <svg
      viewBox={MARK_VIEWBOX}
      height={height}
      width={height * MARK_RATIO}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      <path d={MARK_PATH} fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
    </svg>
  );
}

/**
 * Основная версия логотипа: знак + дескриптор «ДЖИТИО ГРУПП».
 * Брендбук (стр. 14) предписывает именно её для цифровых продуктов и
 * сервисов в www.
 */
export function GtoLogo({ height = 40, className }: { height?: number; className?: string }) {
  // Пропорции локапа зафиксированы обмером исходника: дескриптор по ширине
  // равен знаку, отступ между ними — 18% высоты знака.
  const gap = height * 0.18;
  const descHeight = (height * MARK_RATIO) / DESCRIPTOR_RATIO;

  return (
    <span
      className={className}
      style={{ display: 'inline-flex', flexDirection: 'column', gap, lineHeight: 0 }}
      role="img"
      aria-label="GTO GROUP · ДЖИТИО ГРУПП"
    >
      <svg viewBox={MARK_VIEWBOX} height={height} width={height * MARK_RATIO} aria-hidden focusable="false">
        <path d={MARK_PATH} fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
      </svg>
      <svg
        viewBox={DESCRIPTOR_VIEWBOX}
        height={descHeight}
        width={height * MARK_RATIO}
        aria-hidden
        focusable="false"
      >
        <path d={DESCRIPTOR_PATH} fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
      </svg>
    </span>
  );
}
